<template>
  <div class="py-2 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">{{ isNew ? 'Nova Empresa' : 'Editar Empresa' }}</h5>
              </div>
            </div>
          </div>
          <div class="p-4">
            <form @submit.prevent="onSubmit">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-control-label">Razão Social</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="v$.form.razaoSocial.$model"
                      placeholder="Razão Social"
                    >
                    <div class="input-errors" v-for="(error, index) of v$.form.razaoSocial.$errors" :key="index">
                      <div class="text-danger text-xs">{{ error.$message }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-control-label">Nome Fantasia</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.nomeFantasia"
                      placeholder="Nome Fantasia"
                    >
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-control-label">CNPJ</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="v$.form.documento.$model"
                      @input="formatCNPJ"
                      maxlength="18"
                      placeholder="00.000.000/0000-00"
                    >
                    <div class="input-errors" v-for="(error, index) of v$.form.documento.$errors" :key="index">
                      <div class="text-danger text-xs">{{ error.$message }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-control-label">Unidade</label>
                    <input 
                      type="number" 
                      class="form-control" 
                      v-model="v$.form.conexaUnidadeId.$model"
                      placeholder="Digite o ID da unidade"
                    >
                    <div class="input-errors" v-for="(error, index) of v$.form.conexaUnidadeId.$errors" :key="index">
                      <div class="text-danger text-xs">{{ error.$message }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-12">
                  <div class="d-flex justify-content-between">
                    <router-link :to="{ name: 'Empresas' }">
                      <button type="button" class="btn btn-dark">
                        Voltar
                      </button>
                    </router-link>
                    <button type="submit" class="btn btn-success">
                      {{ isNew ? 'Criar' : 'Salvar' }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';
import { successToast, errorToast } from '@/utils/alerts';
import useVuelidate from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';

export default {
  name: "Empresa",
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      form: {
        razaoSocial: '',
        nomeFantasia: '',
        documento: '',
        conexaUnidadeId: ''
      }
    };
  },
  validations() {
    return {
      form: {
        razaoSocial: {
          required: helpers.withMessage('Razão Social é obrigatória', required)
        },
        documento: {
          required: helpers.withMessage('CNPJ é obrigatório', required)
        },
        conexaUnidadeId: {
          required: helpers.withMessage('Unidade é obrigatória', required)
        }
      }
    };
  },
  computed: {
    isNew() {
      return this.$route.params.id === 'new';
    }
  },
  created() {
    if (!this.isNew) {
      this.fetchEmpresa();
    }
  },
  methods: {
    formatCNPJ() {
      let value = this.v$.form.documento.$model.replace(/\D/g, '');
      if (value.length <= 14) {
        value = value.replace(/^(\d{2})(\d)/, '$1.$2');
        value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
        value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
        value = value.replace(/(\d{4})(\d)/, '$1-$2');
      }
      this.v$.form.documento.$model = value;
    },
    async fetchEmpresa() {
      try {
        const response = await api.get(`/empresa/${this.$route.params.id}`);
        this.form = response.data;
      } catch (error) {
        errorToast('Erro ao carregar dados da empresa');
        console.error(error);
      }
    },
    async onSubmit() {
      const isFormValid = await this.v$.$validate();
      if (!isFormValid) {
        return;
      }

      try {
        const formData = {
          ...this.form,
          conexaUnidadeId: Number(this.form.conexaUnidadeId)
        };

        if (this.isNew) {
          await api.post('/empresa', formData);
          successToast('Empresa criada com sucesso!');
        } else {
          await api.patch(`/empresa/${this.$route.params.id}`, formData);
          successToast('Empresa atualizada com sucesso!');
        }
        this.$router.push({ name: 'Empresas' });
      } catch (error) {
        errorToast('Erro ao salvar empresa');
        console.error(error);
      }
    }
  }
};
</script>
